import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuToggleOption} from '@Components/contextual-menu/components/contextual-menu-toggle-option';

interface BaseItemSepiaOptionProps {
  isChecked: boolean;

  onToggleOption(): void;
}

export function BaseItemSepiaOption({...props}: BaseItemSepiaOptionProps): ReactElement<any> | null {
  return (
    <ContextualMenuToggleOption
      id="item-sepia-contextual-options"
      label={window.i18next.t('pmwjs_sepia')}
      isChecked={props.isChecked}
      onClick={(): void => {
        props.onToggleOption();
      }}
    />
  );
}
